//Horizontal Scroll table columns on mobile
$('.js-scroll-table').on('click', '.js-scroll-left, .js-scroll-right', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $content = $this.closest('.js-scroll-table').find('.js-scroll-table-content');
  const scrollOffset = $content.find('table').width() / $content.find('tr:first-child td').length;

  console.log(scrollOffset);

  if ($this.hasClass('js-scroll-left')) {
    $content.animate({ scrollLeft: '-=' + scrollOffset + 'px' }, 300);
  }

  if ($this.hasClass('js-scroll-right')) {
    $content.animate({ scrollLeft: '+=' + scrollOffset + 'px' }, 300);
  }
});



// WEBPACK FOOTER //
// ./../src/assets/js/table.js